import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";

const BadgeBordered = ({ name = null }) => {
    return (
        name && (
            <Wrapper>
                <TextType content={name} />
            </Wrapper>
        )
    );
};

export default BadgeBordered;

const Wrapper = styled(Flex)`
    border-radius: 4px;
    border: 1px solid var(--color-primary);
    padding: 4px 8px;
`;

const TextType = styled(Text)`
    color: var(--color-primary);
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px; /* 133.333% */
`;
